import PrivateImage from 'Modules/PrivateImage/PrivateImage';
import { arrayOf, func, shape } from 'prop-types';
import { Grid, GridColumn, GridRow } from 'semantic-ui-react';

import EmptyList from '../EmptyList';

const GridImage = ({ list, openPreview }) => {
  const { length } = list;
  if (length < 1) {
    return <EmptyList text="No media files yet" />;
  }
  const result = [];
  for (let i = 0; i < length; i += 2) {
    if (i + 1 < length) {
      result.push([list[i], list[i + 1]]);
    } else {
      result.push([list[i]]);
    }
  }
  return (
    <Grid>
      {result.map((items, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <GridRow columns={2} key={`media-${index}`}>
          {items.map(item => (
            <GridColumn key={item.id}>
              <div style={{ height: '120px', marginRight: '6px', marginBottom: '6px' }}>
                <PrivateImage
                  type="thumbnail"
                  src={item.thumbPath}
                  as="a"
                  onClick={() => {
                    openPreview(item);
                  }}
                  style={{
                    borderRadius: '4px',
                  }}
                />
              </div>
            </GridColumn>
          ))}
        </GridRow>
      ))}
    </Grid>
  );
};

GridImage.propTypes = {
  list: arrayOf(shape({})).isRequired,
  openPreview: func.isRequired,
};

export default GridImage;
